module.exports = __webpack_public_path__ + "media/images/kumu-banner-6e02850b2d1a579e8f5b98575721f8f2.jpg";